import BigNumber from 'bignumber.js';
import { AuthBase } from '../AuthBase';
import {
  idlFactory as depthIDL,
  _SERVICE as DepthActor
} from '@deland-labs/orderbook_depth_client';
import { CanisterError } from '../utils/exception';
import { parseToCommon, toBigNumber } from '../utils/helper';
import { MarketSetting } from './Market';

export enum DepthLevel {
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5,
  Six = 6,
  Seven = 7
}

export interface DepthItem {
  price: BigNumber;
  volume: BigNumber;
}

export enum DepthType {
  All = 1,
  Bid = 2,
  Ask = 3
}

export interface DepthData {
  bids: Array<DepthItem>;
  asks: Array<DepthItem>;
}

export class Depth extends AuthBase {
  private baseTokenDecimals: number;
  private setting: MarketSetting;

  constructor(baseTokenDecimals: number, setting: MarketSetting) {
    super();
    this.baseTokenDecimals = baseTokenDecimals;
    this.setting = setting;
  }

  public getDepth = async (
    level: DepthLevel,
    count: number
  ): Promise<DepthData> => {
    const depth = await this.createDepthActor(this.setting.depthCanisterId);
    const res = await depth.get_depth(level, count);
    if ('Ok' in res) {
      return {
        bids: this.parseOriginDepth(res.Ok.bids),
        asks: this.parseOriginDepth(res.Ok.asks)
      };
    } else throw new CanisterError(res.Err);
  };

  /**
   * parse origin depth data to DepthItem
   * @param originData
   * @returns DepthItem[]
   */
  private parseOriginDepth = (
    originData: Array<[bigint, bigint]>
  ): Array<DepthItem> => {
    const orders: Array<DepthItem> = originData.map(item => {
      return {
        price: toBigNumber(item[0]).shiftedBy(-this.setting.priceDecimals),
        volume: toBigNumber(item[1]).shiftedBy(-this.baseTokenDecimals)
      };
    });
    return orders;
  };

  /**
   * create depth actor
   * @param depthCanisterId  depth canister id
   * @param anonymous is anonymous access
   * @returns
   */
  private createDepthActor = (
    depthCanisterId: string,
    anonymous: boolean = true
  ) => {
    return this.createActor<DepthActor>(depthCanisterId, depthIDL, anonymous);
  };
}
